const RYANAIR_CARRIER_CODES = new Set(["FR", "RYR", "RYANAIR"]);

const normalizeArray = (value) => {
  if (!value) {
    return [];
  }

  return (Array.isArray(value) ? value : [value]).filter(Boolean);
};

export const normalizeCarrierCode = (carrierCode) => {
  if (carrierCode === undefined || carrierCode === null) {
    return "";
  }

  return String(carrierCode)
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
};

export const isRyanairCarrierCode = (carrierCode) =>
  RYANAIR_CARRIER_CODES.has(normalizeCarrierCode(carrierCode));

const addCarrierCode = (carrierCodes, carrierCode) => {
  if (carrierCode) {
    carrierCodes.push(carrierCode);
  }
};

export const getFlightOfferCarrierCodes = (flightOffer) => {
  const carrierCodes = [];

  addCarrierCode(carrierCodes, flightOffer?.MarketingAirline);
  addCarrierCode(carrierCodes, flightOffer?.OperatingAirline);
  addCarrierCode(carrierCodes, flightOffer?.PlatingCarrier);
  addCarrierCode(carrierCodes, flightOffer?.PlattingCarrier);

  normalizeArray(flightOffer?.Brands?.Brand).forEach((brand) => {
    addCarrierCode(carrierCodes, brand?.MarketingAirline);
    addCarrierCode(carrierCodes, brand?.OperatingAirline);
  });

  normalizeArray(flightOffer?.FlightItinerary?.FlightStream).forEach(
    (flightStream) => {
      addCarrierCode(carrierCodes, flightStream?.MarketingAirline);
      addCarrierCode(carrierCodes, flightStream?.OperatingAirline);
      addCarrierCode(carrierCodes, flightStream?.PlatingCarrier);
      addCarrierCode(carrierCodes, flightStream?.PlattingCarrier);

      normalizeArray(flightStream?.FlightOption).forEach((flightOption) => {
        addCarrierCode(carrierCodes, flightOption?.MarketingAirline);
        addCarrierCode(carrierCodes, flightOption?.OperatingAirline);
        addCarrierCode(carrierCodes, flightOption?.PlatingCarrier);
        addCarrierCode(carrierCodes, flightOption?.PlattingCarrier);

        normalizeArray(flightOption?.FlightSegments?.FlightSegment).forEach(
          (flightSegment) => {
            addCarrierCode(carrierCodes, flightSegment?.MarketingAirline);
            addCarrierCode(carrierCodes, flightSegment?.OperatingAirline);
            addCarrierCode(carrierCodes, flightSegment?.PlatingCarrier);
            addCarrierCode(carrierCodes, flightSegment?.PlattingCarrier);
          }
        );
      });
    }
  );

  return carrierCodes;
};

export const isRyanairFlightOffer = (flightOffer) =>
  getFlightOfferCarrierCodes(flightOffer).some(isRyanairCarrierCode);
